// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Subscriptions_TestClockStateResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Subscriptions_TestClockStateResponse — where the clock stands (S11 · C1).
 *
 * Returned by GET /subscriptions/admin/test-clock/{subscription_id}: the
 * accumulated offset plus the full advance history, newest first. This is the
 * read the C4 staff surface (a tab of the staff SubscriptionDetailModal) will
 * render — the offset because it is permanent and someone has to be able to see
 * it, the history because "quem, quando, quantos dias" is the audit the spec
 * demands of an irreversible action.
 *
 * offset_days_total is the newest row's offset_days_after, or 0 when the clock
 * has never been advanced. It is NOT recomputed by summing on the client.
 */
import type { Subscriptions_TestClockAdvanceRow } from './Subscriptions_TestClockAdvanceRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Subscriptions_TestClockStateResponseDados {
offset_days_total: number
advances: Subscriptions_TestClockAdvanceRow[]
}

export type Subscriptions_TestClockStateResponse = ApiResponse<Subscriptions_TestClockStateResponseDados>;

registerResponseContract('Subscriptions_TestClockStateResponse', {
  offset_days_total: { type: 'number',  required: true },
  advances: {
    type: 'array',
    required: true,
    items: {
      id:                { type: 'number',  required: false },
      days:              { type: 'number',  required: false },
      offset_days_after: { type: 'number',  required: false },
      advanced_by:       { type: 'string',  required: false },
      created_at:        { type: 'string',  required: false },
      chronology: {
        type: 'array',
        required: false,
        items: {
          kind:       { type: 'string',  required: false },
          boundary:   { type: 'string',  required: false },
          event_type: { type: 'string',  required: false },
          event_id:   { type: 'string',  required: false },
          outcome:    { type: 'string',  required: false },
          detail:     { type: 'string',  required: false },
          job_type:   { type: 'string',  required: false },
          run_id:     { type: 'number',  required: false },
          summary:    { type: 'string',  required: false },
        },
      },
    },
  },
})
